import React from 'react';
//////variant icon and general

const BlockButton = ({ type, children, disabled, handleClick }) => {
  return (
    <button
      type={type}
      onClick={handleClick}
      disabled={disabled}
      className='px-3 py-[10px] min-w-[120px] border-2 rounded-md text-base border-grey-2 font-bold font-onest-regular transition-colors text-grey-1 hover:text-red active:text-red-burgundy focus:outline-none disabled:bg-grey-3 dark:disabled:bg-grey-1 disabled:text-grey-1 dark:disabled:text-black-3'
    >
      {children}
    </button>
  );
};

export default BlockButton;
